/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { equal } from '@ember/object/computed';
import Model from '@ember-data/model';

interface CioPaginatorArgs {
  page: number;
  totalRecs: number | null;
  itemsPerPage: number;
  model: Model[];
  onPageChange: (page: number) => unknown;
}

export default class CioPaginator extends Component<CioPaginatorArgs> {
  @equal('args.page', 1) isFirstPage!: boolean;
  @equal('args.totalRecs', -1) unknownTotal!: boolean;

  get totalRecs() {
    return this.args.totalRecs ?? 0;
  }

  get hasTotalRecs() {
    return this.args.totalRecs != null;
  }

  get totalPages() {
    if (this.totalRecs === -1) {
      return -1;
    } else {
      return Math.ceil(this.totalRecs / this.args.itemsPerPage);
    }
  }
  get firstRecOnPage() {
    return (this.args.page - 1) * this.args.itemsPerPage + 1;
  }
  get lastRecOnPage() {
    let calculatedLast = this.firstRecOnPage + this.args.itemsPerPage - 1;

    if (this.unknownTotal) {
      // Note that if model is not provided, undefined < this.itemsPerPage evaluates to false
      if (this.args.model?.length < this.args.itemsPerPage) {
        return this.args.model?.length;
      } else {
        return calculatedLast;
      }
    } else {
      return Math.min(this.totalRecs, calculatedLast);
    }
  }
  get isLastPage() {
    if (this.unknownTotal) {
      return this.args.model?.length < this.args.itemsPerPage;
    } else {
      return !this.totalPages || this.args.page === this.totalPages;
    }
  }

  @action
  previousPage() {
    this.args.onPageChange(Math.max(1, this.args.page - 1));
  }
  @action
  nextPage() {
    let nextPage = this.totalPages === -1 ? this.args.page + 1 : Math.min(this.totalPages, this.args.page + 1);
    this.args.onPageChange(nextPage);
  }
}
